import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import ReactJson from "react-json-view";
import { DownloadJsonButton } from "components/buttons";
import DataGrid, { DataGridItem } from "components/data-grid";

const EvuTemplateTab = ({ event }) => {
  // event.evu se resuelve de forma asíncrona e independiente del resto del evento
  // (useEventDetailsRest), así que puede llegar `null` momentáneamente tras montar este tab.
  if (!event.evu) {
    return null;
  }

  const json = JSON.parse(event.evu);

  return (
    <DataGrid>
      <DataGridItem>
        <DownloadJsonButton data={json} filename={`${event.title} (EVU).json`} />
      </DataGridItem>
      <DataGridItem big>
        <ReactJson
          src={json}
          groupArraysAfterLength={1}
          enableClipboard={false}
          displayObjectSize={false}
          displayDataTypes={false}
          collapseStringsAfterLength={false}
        />
      </DataGridItem>
    </DataGrid>
  );
};

EvuTemplateTab.propTypes = {
  /**
   ** Evento
   **/
  event: PropTypes.object,
};

export default injectIntl(EvuTemplateTab);
